import React from 'react'
import Find from '../share/components/Find/Find'
import CarouselSevices, { servicesTravel } from '../share/components/CarouselServices/CarouselSevices'
import AllCardsPharmacy from './AllCards/AllCardsPharmacy'
import usePharmacy from '../../viewModels/pharmacy/usePharmacy'
import Paginado from './Paginado/Paginado'
import ButtonsFilters from './ButtonsFilters/ButtonsFilters'


const Pharmacy = () => {

  const {
    dataPharmacy,
    loading,
    nextHandler,
    prevHandler,
    currentPage,
    mostrarNext,
    services,
    filterNamePharmacy,
    detailPharmacy
  } = usePharmacy()

  return (
    <div>
       <Find />
       <CarouselSevices current={servicesTravel[10].title}/>
       <ButtonsFilters filterNamePharmacy={filterNamePharmacy}/>
       <AllCardsPharmacy dataPharmacy={dataPharmacy} loading={loading} detailPharmacy={detailPharmacy}/>
       <Paginado currentPage={currentPage} data={services} mostrarNext={mostrarNext} prevHandler={prevHandler} nextHandler={nextHandler}/>
    </div>
  )
}

export default Pharmacy